import { Container, Grid } from "@mui/material";
import { StyledHeadingWithGradientunderline } from "@Styled/Pages/Landing/Category";
import {
  StyledContent,
  StyledGridContainer,
  StyledTitle,
} from "@Styled/Pages/Prefooter";

const PrivacyPolicy = () => {
  return (
    <>
      <Container sx={{ marginBottom: "5rem" }}>
        <StyledGridContainer container>
          <StyledHeadingWithGradientunderline
            variant="subtitle1"
            sx={{
              fontSize: { sm: "1.5rem", xs: "1.2rem" },
              letterSpacing: "-1px",
            }}
          >
            Terms & Condition{" "}
          </StyledHeadingWithGradientunderline>
        </StyledGridContainer>

        <StyledTitle> Copyright & Legal Disclaimer</StyledTitle>
        <StyledContent>
          {" "}
          Please carefully review the following terms and conditions of use
          (“Terms and Conditions”), which apply to everyone who visits this
          ECONUT India Pvt. Ltd. (“ECONUT”) website. By accessing and using this
          website, you are agreeing to abide by, and be bound by, the following
          Terms and Conditions and any amendments in effect at the time of your
          visit. ECONUT may modify these Terms and Conditions at any time
          without notice by updating these legal notices, and we encourage you
          to review the Terms and Conditions because any such modifications will
          be binding on you.
        </StyledContent>
        <StyledTitle> Copyright / Trademark Notice </StyledTitle>
        <StyledContent>
          {" "}
          Trademarks and service marks on this ECONUT website, including but not
          limited to product names, are registered and unregistered trademarks
          of ECONUT and others. The contents of this ECONUT website (including,
          without limitation, the arrangement and layout of the websites; names
          and logos; and text, illustrations and artwork) are the copyrighted
          and/or trademarked property of ECONUT (or the original creator of the
          material) and are protected under applicable copyright and trademark
          laws. Nothing contained on the websites should be construed as
          granting any license or right to use any such marks or copyrighted
          material without the written permission of ECONUT or such other party
          who may own such mark(s) or copyrighted material. Any unauthorized use
          of the trademarks, copyrights or other contents of this ECONUT website
          may violate civil or criminal laws.
        </StyledContent>
        <StyledTitle> Product Catalog </StyledTitle>
        <StyledContent>
          {" "}
          The Content (as defined below) presented on this Website is intended
          for educational or informational purposes only. Such information is
          not meant to serve as a substitute for professional medical advice.
          Please consult with your own physician or healthcare practitioner
          regarding the use of any goods, products or information available on
          or received from this Website. Your physician or health care
          practitioner should address any and all medical questions, concerns
          and decisions regarding the possible treatment of any medical
          condition. In addition, the statements made about products have not
          been evaluated by any of the Food and Drug Administration agencies, if
          any, may not necessarily occur in all individuals. Please consult with
          your own physician or healthcare practitioner regarding the use of any
          goods, products or information received from this Website before using
          or relying on them. Your physician or healthcare practitioner should
          address any and all medical questions, concerns and decisions
          regarding the possible treatment of any medical condition. You should
          always check the ingredients for products to avoid potential allergic
          reactions as ECONUT may change ingredients from time to time. ECONUT
          does not give or intend to give any answers to medical-related
          questions and this Website does not replace any medical professional
          or medical resource. ECONUT does not represent itself as a physician
          nor is this implied. No prescription medications or medical treatments
          are intentionally provided on this Website.
        </StyledContent>
        <StyledTitle> Images & Colors </StyledTitle>
        <StyledContent>
          {" "}
          We try to accurately display the actual look of the products you see
          on the Website. However, we cannot guarantee that the actual
          appearance and you see on your monitor will be similar.
        </StyledContent>
        <StyledTitle> No Advice </StyledTitle>
        <StyledContent>
          {" "}
          Nothing contained in ECONUT&apos;s website should be construed as
          medical, legal, investment, financial or other advice. Without
          limitation, nothing contained in the sites should replace medical
          advice, medical visits or recommendations from health care providers.
          Patients should always consult with a doctor or other health care
          provider for medical advice.
        </StyledContent>
        <StyledTitle> Links </StyledTitle>
        <StyledContent>
          {" "}
          ECONUT&apos;s website contains links to third-party websites, which
          are provided as a convenience to users of our site. ECONUT makes no
          claim or warranty of, and is not responsible for, any information
          found in a linked website. We encourage you to check the disclaimers
          and other legal notices provided on such linked sites.
        </StyledContent>
        <StyledTitle> No Representation or Warranty </StyledTitle>
        <StyledContent>
          {" "}
          While ECONUT uses reasonable efforts to include up-to-date and
          accurate information on its website, ECONUT does not make, and
          expressly disclaims, any representations or warranties of any kind,
          either express or implied (including without limitation any implied
          warranties of merchantability, fitness for a particular purpose or
          non-infringement) with regard to any such information, its accuracy or
          completeness or the frequency that it is updated. Everything on
          ECONUT&apos;s website is provided “AS IS”. ECONUT assumes no liability
          or responsibility for any errors or omissions in the content of its
          websites.
        </StyledContent>
        <StyledTitle> Limitation of Liability </StyledTitle>
        <StyledContent>
          {" "}
          Your use of ECONUT&apos;s website is at your own risk. In no event
          shall ECONUT or any of its officers, directors, employees or
          affiliates, be liable, directly or indirectly, for any damages of any
          kind or nature, including, without limitation, direct, incidental,
          punitive or consequential, or any claims or losses, resulting from or
          in connection with the creation or use of, or reliance on, this site
          or any information contained herein, any other ECONUT website or any
          linked website contained in any such sites, or any of the information
          accessed through any such site or from the inability to use any such
          site. This limitation includes damage to your computer equipment or
          any viruses that may infect your computer equipment or other property.
        </StyledContent>
        <StyledTitle> We Listen </StyledTitle>
        <StyledContent>
          {" "}
          Comments and Feedback: We welcome your suggestions, feedback, ideas
          and other submissions (collectively “User Contributions”) about the
          Website, its Content, and our products. If any user contribution
          includes ideas, suggestions, documents or proposals to ECONUT, you
          hereby acknowledge and agree that: (a) such User Contributions are not
          confidential or proprietary and ECONUT has no obligation of
          confidentiality, express or implied, with respect thereto; (b) ECONUT
          may have something similar to the User Contribution already under
          consideration or development; and (c) you are not entitled to
          compensation, payment or reimbursement of any kind from ECONUT or any
          of its affiliates for such User Contribution under any circumstances
          unless you are otherwise notified by ECONUT in writing to the
          contrary. By submitting or sending User Contribution to us, you: (i)
          represent and warrant that the User Contribution are original to you,
          that no other party has any rights thereto, and that any &apos;moral
          rights&apos; in the User Contributions have been waived, and (ii) you
          grant us and our affiliates a royalty-free, unrestricted, worldwide,
          perpetual, irrevocable, non-exclusive and fully transferable,
          assignable and sublicensable right and license to use, copy,
          reproduce, modify, adapt, publish, translate, create derivative works
          from, distribute, perform, display, make, sell and export such User
          Contributions (in whole or part) and/or to incorporate it in other
          works in any form, media, or technology now known or later developed,
          for editorial, commercial, non-commercial, promotional or any other
          purpose. We cannot be responsible for maintaining any User
          Contributions that you provide to us, and we may delete or destroy any
          such User Contributions at any time. Any User Contributions will be
          deemed not to be confidential or secret, and may be used by us in any
          manner not inconsistent with these Terms of Use and the Website&apos;s
          Privacy Policy.
        </StyledContent>
        <StyledTitle> Governing Law </StyledTitle>
        <StyledContent>
          {" "}
          These Terms and Conditions of use and your use of this website shall
          be governed by the laws of the State of Gujarat without regard to
          conflict of laws principles. Any legal action or proceeding related to
          the Terms and Conditions or your use of this website shall be brought
          exclusively in the courts of the State of Gujarat.
        </StyledContent>
        <StyledTitle> In General </StyledTitle>
        <StyledContent>
          {" "}
          These Terms and Conditions along with the Privacy Policy, the Return
          Policy, Shipping Policy, Cancellation Policy or any other Policy or
          Statement or Information that may be placed on this website
          (hereinafter referred to as &apos;Site&apos; or
          &apos;www.econut.store&apos; or &apos;we&apos; or &apos;our&apos;or
          “Company”), as modified or amended from time to time, are a binding
          contract between the company and you (hereinafter referred to as
          &apos;Terms and Conditions&apos; or &apos;T&C&apos; or
          &apos;Terms&apos; or &apos;Agreement&apos;). If you visit, use, or
          shop at the site or any future site operated by the company, you
          accept these Terms and Conditions. In addition, when you use any
          current or future services of the company or visit or purchase from
          any business affiliated with the company or third party vendors,
          whether or not included in the site, you also will be subject to the
          guidelines and conditions applicable to such service or merchant. If
          these conditions are inconsistent with such guidelines and conditions,
          such guidelines and conditions will control.
        </StyledContent>
        <StyledContent>
          {" "}
          You (&apos;you&apos; or &apos;End User&apos; or &apos;your&apos; or
          &apos;Buyer&apos; or &apos;Customer&apos;) by subscribing to or using
          any of our products or services, you agree that you have read,
          understood and are bound by the Terms and Conditions , regardless of
          how you subscribe to or use our products or services. If you do not
          want to be bound by the terms, you must not subscribe to or use our
          services.
        </StyledContent>
        <StyledContent>
          {" "}
          This T&C is effective upon your subscription and governs the
          relationship between you and ECONUT India Private Limited (hereinafter
          &apos;Company&apos;) including the sale and supply of any Products on
          the site. If this T&C conflicts with any other document, the T&C will
          prevail for the purposes of usage of the Site. If you do not agree to
          be bound by this T&C and the Privacy Policy, you may not use the Site
          in any way.
        </StyledContent>
        <StyledContent>
          {" "}
          The Company reserves the right at all times to discontinue or modify
          any of our T&C as we deem necessary or desirable without prior
          notification to you. Such changes may include, among other things, the
          adding of certain fees or charges. We suggest to you, therefore, that
          you re-read this important notice containing our T&C from time to time
          in order that you stay informed as to any such changes. If we make
          changes to our T&C and you continue to use the Site, you are impliedly
          agreeing to the T&C expressed therein. Any such deletions or
          modifications shall be effective immediately upon the Company&apos;s
          posting thereof. Any use of the Site by User after such notice shall
          be deemed to constitute acceptance by the User of such modifications.
        </StyledContent>
        <StyledContent>
          {" "}
          The Service is not available to minors under the age of 18 or to any
          users suspended or removed from the system by{" "}
          <a href="https://econut.store/" style={{ color: "#00844a" }}>
            www.econut.store
          </a>{" "}
          for any reason. Users may not have more than one account. Maintaining
          more than one account by a user shall amount to fraudulent act on part
          of the user and attract actions against such users. Additionally,
          users are prohibited from selling, trading, or otherwise transferring
          your{" "}
          <a href="https://econut.store/" style={{ color: "#00844a" }}>
            www.econut.store
          </a>{" "}
          account to another party. If you do not qualify, you may not use the
          Service or the Site.
        </StyledContent>
        <StyledContent>
          {" "}
          The Company owns no responsibility in any manner over any dispute
          arising out of transactions by any third party using your
          account/e-mail provided by you to the Company or payments made by your
          credit card by any third party.
        </StyledContent>
        <StyledContent>
          In consideration of your use of the Site, you represent that you are
          of legal age to form a binding contract and are not a person barred
          from receiving services under the laws as applicable in India. You
          also agree to provide true, accurate, current and complete information
          about yourself as prompted by the Site&apos;s registration form. If
          you provide any information that is untrue, inaccurate, not current or
          incomplete (or becomes untrue, inaccurate, not current or incomplete),
          or
          <a href="https://econut.store/" style={{ color: "#00844a" }}>
            www.econut.store
          </a>
          has reasonable grounds to suspect that such information is untrue,
          inaccurate, not current or incomplete,{" "}
          <a href="https://econut.store/" style={{ color: "#00844a" }}>
            www.econut.store
          </a>{" "}
          has the right to suspend or terminate your account and refuse any and
          all current or future use of the Site (or any portion thereof). If you
          use the Site, you are responsible for maintaining the confidentiality
          of your account and password including cases when it is being used by
          any of your family members, friends or relatives, whether a minor or
          an adult. You further agree to accept responsibility for all
          transactions made from your account and any dispute arising out of any
          misuse of your account, whether by any family member, friend,
          relative, any third party or otherwise shall not be entertained by the
          Company. Because of this, we strongly recommend that you exit from
          your account at the end of each session. You agree to notify{" "}
          <a href="https://econut.store/" style={{ color: "#00844a" }}>
            www.econut.store
          </a>{" "}
          immediately of any unauthorized use of your account or any other
          breach of security.{" "}
          <a href="https://econut.store/" style={{ color: "#00844a" }}>
            www.econut.store
          </a>{" "}
          reserves the right to refuse service, terminate accounts, or remove or
          edit content in its sole discretion.
        </StyledContent>
      </Container>
    </>
  );
};
export default PrivacyPolicy;
